import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useBorrowAmountStyle = createUseStyles({
    noCollateralAlert: {
        marginTop: spacing['04'],
    },
    text: {
        marginBottom: spacing['03'],
        fontWeight: 500,
    },
    error: {
        color: color.content.negative,
        marginTop: spacing['02'],
    },
});
